import { Component, HostBinding, AfterViewChecked } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { OpenIdConnectService } from './services/oidc/open-id-connect.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { environment } from '../environments/environment';
import { SessionTimer } from './services/sessionTimer';
import * as $ from 'jquery';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'app';

    constructor(private oidcService: OpenIdConnectService, idle: Idle, keepAlive: Keepalive, dialog: MatDialog) {
        //toastr.options.positionClass = 'toast-bottom-right';
        
        this.oidcService.userLoaded$.subscribe(loaded => {
            if (loaded && !this.oidcService.internal) {
                var sessionTimer = new SessionTimer(this.oidcService, idle, keepAlive, dialog);
                sessionTimer.startTimeout();
            }
        });
    }

    ngOnInit() {
    }
}
